import { render } from "./BlCollectionMove.vue?vue&type=template&id=e6ea6c36&scoped=true"
import script from "./BlCollectionMove.vue?vue&type=script&lang=js"
export * from "./BlCollectionMove.vue?vue&type=script&lang=js"

import "./BlCollectionMove.vue?vue&type=style&index=0&id=e6ea6c36&scoped=true&lang=scss"

import exportComponent from "/tmp/4f365a42-b3f2-4061-98cc-f7413900e2b1/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6ea6c36"]])

export default __exports__